import { render } from "./StepWizard.vue?vue&type=template&id=3dfe08b1&scoped=true&ts=true"
import script from "./StepWizard.vue?vue&type=script&lang=ts"
export * from "./StepWizard.vue?vue&type=script&lang=ts"

import "./StepWizard.vue?vue&type=style&index=0&id=3dfe08b1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfe08b1"]])

export default __exports__